module.exports = __webpack_public_path__ + "static/media/complaint.d94c1ace.svg";